module.exports = __webpack_public_path__ + "assets/language.svg";